// extracted by mini-css-extract-plugin
module.exports = {"main":"VideoPlayer_main__2B0E7","wrapper":"VideoPlayer_wrapper__2AUUz"};